module.exports = __webpack_public_path__ + "img/18.7.Chla.0e799194.png";